export default __webpack_public_path__ + "static/hero-1-aaa8f912764f66a0926e93afb684eccc.jpg";